// MobileBottomTabBar — fixed bottom navigation for mobile CRM screens.
// Matches the "Variation A" tab bar from the Claude Design mockup.
// Reused across mobile/Dashboard, /Leads, /Tasks, /Follow-Up, /More routes.

import { NavLink } from "react-router-dom";

const ACTIVE = "#6366F1";
const IDLE   = "#9AA0AE";

function TabItem({ to, label, active, children }) {
  return (
    <NavLink
      to={to}
      className="flex flex-col items-center gap-1 flex-1 no-underline"
      style={{ color: active ? ACTIVE : IDLE }}
    >
      {children}
      <span className="text-[10px] font-bold tracking-wide">{label}</span>
    </NavLink>
  );
}

export default function MobileBottomTabBar({ active = "home" }) {
  // SVG icons are hand-inlined to match the design precisely (lucide approximations were off)
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-30 bg-white border-t border-[#EEEEF4] flex items-start justify-around"
      style={{
        padding: "9px 12px calc(env(safe-area-inset-bottom, 0px) + 18px)",
        boxShadow: "0 -6px 20px rgba(20,20,50,.04)",
        fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
      }}
      data-testid="mobile-tab-bar"
    >
      <TabItem to="/dashboard" label="Home" active={active === "home"}>
        {active === "home" ? (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
            <rect x="3" y="3" width="7" height="7" rx="2" fill="#6366F1" />
            <rect x="14" y="3" width="7" height="7" rx="2" fill="#6366F1" opacity=".4" />
            <rect x="3" y="14" width="7" height="7" rx="2" fill="#6366F1" opacity=".4" />
            <rect x="14" y="14" width="7" height="7" rx="2" fill="#6366F1" opacity=".4" />
          </svg>
        ) : (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
            <rect x="3" y="3" width="7" height="7" rx="2" stroke="currentColor" strokeWidth="1.8" />
            <rect x="14" y="3" width="7" height="7" rx="2" stroke="currentColor" strokeWidth="1.8" />
            <rect x="3" y="14" width="7" height="7" rx="2" stroke="currentColor" strokeWidth="1.8" />
            <rect x="14" y="14" width="7" height="7" rx="2" stroke="currentColor" strokeWidth="1.8" />
          </svg>
        )}
      </TabItem>
      <TabItem to="/leads" label="Leads" active={active === "leads"}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
          <circle cx="9" cy="8" r="3.2" stroke="currentColor" strokeWidth="1.8" />
          <path d="M3.5 19c0-3 2.5-5 5.5-5s5.5 2 5.5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          <circle cx="17" cy="9" r="2.4" stroke="currentColor" strokeWidth="1.8" />
          <path d="M16 14.2c2.3.2 4.2 2 4.2 4.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      </TabItem>
      <TabItem to="/work-hub/tasks" label="Tasks" active={active === "tasks"}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
          <rect x="3.5" y="3.5" width="17" height="17" rx="4.5" stroke="currentColor" strokeWidth="1.8" />
          <path d="M8 12l3 3 5-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </TabItem>
      <TabItem to="/calendar" label="Follow-Up" active={active === "followup"}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
          <rect x="3.5" y="5" width="17" height="15" rx="3.5" stroke="currentColor" strokeWidth="1.8" />
          <path d="M3.5 9.5h17M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      </TabItem>
      <TabItem to="/notifications" label="More" active={active === "more"}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
          <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
        </svg>
      </TabItem>
    </nav>
  );
}
